import { Injectable, NgZone } from '@angular/core';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {

// 60 minutes (1 hour) in milliseconds
  private readonly idleTimeoutMs = 60 * 60 * 1000;

  private timeoutId: any;
  private isWatching = false;

  private readonly activityEvents = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

  constructor(private authService: AuthService, private ngZone: NgZone) {}

  startWatching(): void {
    if (this.isWatching) {
      return;
    }

    this.isWatching = true;

    // Run listeners outside Angular to avoid unnecessary change detection
    this.ngZone.runOutsideAngular(() => {
      this.activityEvents.forEach((eventName) => {
        window.addEventListener(eventName, this.resetTimer, true);
      });
    });

    // Initialize the first timer
    this.resetTimer();
  }

  stopWatching(): void {
    if (!this.isWatching) {
      return;
    }

    this.isWatching = false;

    this.activityEvents.forEach((eventName) => {
      window.removeEventListener(eventName, this.resetTimer, true);
    });

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  private resetTimer = (): void => {
    if (!this.isWatching) {
      return;
    }

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.timeoutId = setTimeout(() => {
      // When idle time is reached, run back inside Angular and logout
      this.ngZone.run(() => {
        this.handleIdleTimeout();
      });
    }, this.idleTimeoutMs);
  };

  private handleIdleTimeout(): void {
    this.stopWatching();
    // Use existing logout flow so user is redirected to login page
    this.authService.SessionTimeout();
  }
}
